/* POVA PDP — minimal glass commerce card behaviour.
 *
 * Drives snippets/pdp-commerce.liquid:
 *   • specs icon (.pdp-more)  → opens the full-screen categorized spec sheet
 *   • Colour / Storage chips  → each opens a floating dropdown menu (one at a time)
 *   • swatch select           → swaps hero render (#xp-hero-img) + field glow,
 *                               resolves the variant, updates the price
 *   • storage select          → resolves the variant, updates the price
 *   • Add to Bag              → carries the resolved variant id; the site-wide
 *                               cart handler (js-commerce.js) does /cart/add.js
 *   • auto-tuck               → card hides while moving down through content,
 *                               returns on upward intent / at ends
 */
(function () {
  "use strict";

  function ready(fn) { document.readyState !== "loading" ? fn() : document.addEventListener("DOMContentLoaded", fn); }

  ready(function () {
    var dock = document.querySelector(".pdp-dock");
    if (!dock) return;

    /* ---------- Variant map ---------- */
    var vmap = null;
    var vEl = document.querySelector("[data-pdp-variants]");
    if (vEl) { try { vmap = JSON.parse(vEl.textContent); } catch (e) { vmap = null; } }
    var addBtn = document.querySelector("[data-add-to-cart]");
    var buyLabel = addBtn ? addBtn.querySelector(".pdp-isl__buy-label") : null;

    var sel = { colour: null, storage: null };
    var firstSwatch = document.querySelector('[data-swatch][aria-pressed="true"]') || document.querySelector("[data-swatch]");
    if (firstSwatch) sel.colour = firstSwatch.getAttribute("data-label");
    var firstStore = document.querySelector('[data-store][aria-pressed="true"]') || document.querySelector("[data-store]");
    if (firstStore) sel.storage = firstStore.getAttribute("data-label");

    /* A11Y (WCAG 2.4.3): after a swatch/storage is chosen the menu closes, so
       return focus to the chip that triggered it instead of dropping it to <body>. */
    function returnFocusToChip(el) {
      var chip = el && el.closest ? el.closest(".pdp-chip") : null;
      var btn = chip && chip.querySelector("[data-chipbtn]");
      if (btn && btn.focus) { try { btn.focus(); } catch (e) {} }
    }

    function resolveVariant() {
      if (!vmap || !vmap.variants || !vmap.variants.length) return null;
      var ci = vmap.colourIndex, si = vmap.storageIndex;
      var m = vmap.variants.filter(function (v) {
        var okc = (ci < 0) || (sel.colour == null) || (v.options[ci] === sel.colour);
        var oks = (si < 0) || (sel.storage == null) || (v.options[si] === sel.storage);
        return okc && oks;
      })[0];
      return m || vmap.variants[0];
    }

    function updatePrice(now, was) {
      var nowEl = document.querySelector("[data-price-now]");
      var wrap = document.querySelector(".pdp-price");
      if (nowEl && now) nowEl.textContent = now;
      if (!wrap) return;
      var wasEl = wrap.querySelector(".pdp-price__was");
      if (was) {
        if (!wasEl) { wasEl = document.createElement("s"); wasEl.className = "pdp-price__was"; wasEl.setAttribute("data-price-was", ""); wrap.appendChild(wasEl); }
        wasEl.textContent = was;
      } else if (wasEl) { wasEl.parentNode.removeChild(wasEl); }
    }

    function applyVariant() {
      var v = resolveVariant();
      if (!v) return;
      if (addBtn) {
        addBtn.setAttribute("data-variant-id", v.id);
        if (v.available === false) {
          addBtn.setAttribute("disabled", "");
          if (buyLabel) buyLabel.textContent = "Sold out";
        } else {
          addBtn.removeAttribute("disabled");
          if (buyLabel && buyLabel.textContent === "Sold out") buyLabel.textContent = "Add to Bag";
        }
      }
      if (v.price) updatePrice(v.price, v.was);
    }

    /* ---------- Chip dropdowns (one open at a time) ---------- */
    var chips = [].slice.call(document.querySelectorAll(".pdp-chip"));
    function closeAllMenus(except) {
      chips.forEach(function (c) {
        if (c === except) return;
        var menu = c.querySelector("[data-menu]");
        var btn = c.querySelector("[data-chipbtn]");
        if (menu) menu.hidden = true;
        if (btn) btn.setAttribute("aria-expanded", "false");
      });
    }
    chips.forEach(function (c) {
      var btn = c.querySelector("[data-chipbtn]");
      var menu = c.querySelector("[data-menu]");
      if (!btn || !menu) return;
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        var isOpen = !menu.hidden;
        closeAllMenus(c);
        menu.hidden = isOpen;
        btn.setAttribute("aria-expanded", isOpen ? "false" : "true");
      });
    });
    document.addEventListener("click", function (e) { if (!e.target.closest(".pdp-chip")) closeAllMenus(null); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAllMenus(null); });

    /* Colour swatches */
    var swatches = [].slice.call(document.querySelectorAll("[data-swatch]"));
    var colourDot = document.querySelector("[data-colour-dot]");
    var colourVal = document.querySelector("[data-colour-label]");

    /* Reduced-motion is read live so the OS toggle is honoured without a reload. */
    function reduced() { return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches; }

    /* Preload every finish's hero render so a colour swap cross-fades with no gap
       (DESIGN-MOTION-PLAN P8). */
    swatches.forEach(function (sw) {
      var a = sw.getAttribute("data-asset");
      if (a) { var pre = new Image(); pre.src = a; }
    });

    /* Cross-dissolve a hero <img> to a new src (P8): clone the current image as an
       overlay that fades out (180ms) while the real image takes the new src and
       fades in from opacity 0 + scale 1.015 -> 1 (360ms) — overlapping, so it
       dissolves rather than blinks. Transform/opacity only. Never runs on first
       paint (LCP) — only on user-initiated colour changes. Under reduced motion,
       or for a hidden img (e.g. the mobile render on desktop), it swaps instantly. */
    function crossFadeHero(img, asset) {
      if (!img || !asset) return;
      if (reduced() || !img.offsetParent || img.offsetWidth === 0) {
        img.src = asset; img.removeAttribute("srcset"); return;
      }
      var host = img.offsetParent || img.parentNode;
      var l = img.offsetLeft, t = img.offsetTop, w = img.offsetWidth, h = img.offsetHeight;
      var clone = img.cloneNode(false);
      clone.removeAttribute("id");
      clone.removeAttribute("data-hero-mobile");
      clone.setAttribute("aria-hidden", "true");
      clone.className = (img.className ? img.className + " " : "") + "xp-hero-xfade";
      clone.style.cssText += "position:absolute;margin:0;pointer-events:none;left:" + l + "px;top:" + t + "px;width:" + w + "px;height:" + h + "px;";
      host.appendChild(clone);
      img.src = asset; img.removeAttribute("srcset");
      img.classList.add("xp-hero-xfade-enter");
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          img.classList.add("is-xfaded");
          clone.classList.add("is-out");
        });
      });
      setTimeout(function () {
        img.classList.remove("xp-hero-xfade-enter", "is-xfaded");
        if (clone.parentNode) clone.parentNode.removeChild(clone);
      }, 460);
    }

    function selectSwatch(sw, swapImage, animate) {
      swatches.forEach(function (o) { o.setAttribute("aria-pressed", o === sw ? "true" : "false"); });
      var label = sw.getAttribute("data-label") || "";
      var glow = sw.getAttribute("data-glow");
      var asset = sw.getAttribute("data-asset");
      sel.colour = label;
      if (colourVal) colourVal.textContent = label;
      if (colourDot && glow) colourDot.style.background = glow;
      if (swapImage && asset) {
        var img = document.getElementById("xp-hero-img");
        var imgM = document.getElementById("xp-hero-img-m");
        if (animate) {
          if (img) crossFadeHero(img, asset);
          if (imgM) crossFadeHero(imgM, asset);
        } else {
          if (img) { img.src = asset; img.removeAttribute("srcset"); }
          if (imgM) { imgM.src = asset; imgM.removeAttribute("srcset"); }
        }
      }
      if (glow) {
        var root = document.documentElement;
        root.style.setProperty("--glow-color", glow);
        root.style.setProperty("--field-halo-color", glow);
      }
      applyVariant();
    }
    swatches.forEach(function (sw) {
      sw.addEventListener("click", function (e) {
        e.stopPropagation();
        selectSwatch(sw, true, true);
        closeAllMenus(null);
        returnFocusToChip(sw);
      });
    });

    /* Storage list */
    var stores = [].slice.call(document.querySelectorAll("[data-store]"));
    var storageVal = document.querySelector("[data-storage-label]");
    stores.forEach(function (st) {
      st.addEventListener("click", function (e) {
        e.stopPropagation();
        stores.forEach(function (o) { o.setAttribute("aria-pressed", o === st ? "true" : "false"); });
        sel.storage = st.getAttribute("data-label");
        if (storageVal) storageVal.textContent = sel.storage;
        applyVariant();
        closeAllMenus(null);
        returnFocusToChip(st);
      });
    });

    /* Sync to the initial selection on load. When a colour is selected, mirror a
       click on it so the hero render, field glow and price all match the dock's
       default colour — a product's configured hero image may differ from its
       first finish, and this keeps the opening state internally consistent. */
    if (firstSwatch) { selectSwatch(firstSwatch, true, false); } else { applyVariant(); }

    /* ---------- Full spec overlay ---------- */
    var moreBtn = document.querySelector(".pdp-more");
    var specs = document.getElementById("pdp-specs");
    if (moreBtn && specs) {
      var closeBtn = specs.querySelector(".pdp-specs__close");
      function openSpecs() {
        closeAllMenus(null);
        specs.hidden = false;
        requestAnimationFrame(function () {
          specs.classList.add("is-open");
          /* Move focus into the dialog so keyboard + screen-reader users land
             inside it; Escape / the close button return focus to moreBtn. */
          if (closeBtn) { try { closeBtn.focus(); } catch (e) {} }
        });
        moreBtn.setAttribute("aria-expanded", "true");
        document.body.classList.add("pdp-specs-open");
      }
      function closeSpecs() {
        specs.classList.remove("is-open");
        moreBtn.setAttribute("aria-expanded", "false");
        document.body.classList.remove("pdp-specs-open");
        try { moreBtn.focus(); } catch (e) {}
        /* Finalize only on the backdrop's OWN transition (or the timeout), not on a
           child row/sheet transition bubbling up, so the close plays out fully. */
        var done = function (e) { if (e && e.target !== specs) return; specs.hidden = true; specs.removeEventListener("transitionend", done); };
        specs.addEventListener("transitionend", done);
        setTimeout(function () { if (!specs.classList.contains("is-open")) specs.hidden = true; }, 460);
      }
      moreBtn.addEventListener("click", function (e) { e.stopPropagation(); openSpecs(); });
      if (closeBtn) closeBtn.addEventListener("click", closeSpecs);
      /* Scrim close: clicking the backdrop or the sheet's own padding (not a row) closes. */
      var sheet = specs.querySelector(".pdp-specs__sheet");
      specs.addEventListener("click", function (e) { if (e.target === specs || e.target === sheet) closeSpecs(); });
      specs.addEventListener("wheel", function (e) { e.stopPropagation(); }, { passive: true });
      specs.addEventListener("touchmove", function (e) { e.stopPropagation(); }, { passive: true });
      /* Focus trap (WCAG 2.4.3 dialog pattern) — mirrors the proven trapTab() in
         js-xp-story.js: while the spec sheet is open, Tab from the last focusable
         wraps to the first and Shift+Tab from the first wraps to the last, so focus
         can never leave the dialog into the deck behind it. Focus-in on open,
         focus-return on close + Escape are already handled above. */
      function specsFocusable() {
        var nodes = specs.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        return Array.prototype.filter.call(nodes, function (el) { return !el.disabled && el.offsetParent !== null; });
      }
      function trapSpecsTab(e) {
        if (e.key !== "Tab") return;
        var f = specsFocusable();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first || !specs.contains(document.activeElement)) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last || !specs.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
        }
      }
      document.addEventListener("keydown", function (e) {
        if (specs.hidden) return;
        if (e.key === "Escape") { closeSpecs(); return; }
        if (e.key === "Tab") trapSpecsTab(e);
      });
    }

    /* ---------- Dock visibility: present on content frames, hidden on the footer ----------
       The buy island stays consistent across every product CONTENT frame and tucks
       away only on the FOOTER frame (the big POVA wordmark panel) so it never overlaps
       it. An IntersectionObserver on the footer is the single source of truth: once the
       footer frame is at least half on screen the dock tucks (existing .is-tucked —
       slides down + fades, pointer-events off; reduced-motion makes it instant), and it
       returns the moment the deck scrolls back into product content. An open spec sheet
       or menu forces it visible so its controls stay reachable. (Replaces the old
       scroll-direction auto-tuck, which hid the dock mid-content on downward scroll and,
       worse, SHOWED it over the footer.) */
    function anyMenuOpen() { return !!document.querySelector("[data-menu]:not([hidden])"); }
    var footerInView = false;
    var ticking = false;
    function syncDock() {
      ticking = false;
      if (document.body.classList.contains("pdp-specs-open") || anyMenuOpen()) { dock.classList.remove("is-tucked"); return; }
      dock.classList.toggle("is-tucked", footerInView);
    }
    var footerEl = document.querySelector(".footer") || document.querySelector("footer");
    if (footerEl && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        footerInView = e.intersectionRatio >= 0.5;
        syncDock();
      }, { threshold: [0, 0.25, 0.5, 0.75, 1] }).observe(footerEl);
    }
    window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(syncDock); } }, { passive: true });
    syncDock();
  });
})();
